module.exports = __webpack_public_path__ + "img/collectNot.495fe355.svg";